module.exports = __webpack_public_path__ + "static/img/background1.61b4379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background1.jpg
// module id = Un8Q
// module chunks = 0